// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3HGHf","box":"WorkspacesBox_box__fYn8D","node":"WorkspacesBox_node__2TcIk"};